import { Select, Skeleton } from "antd";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import HTTP from "../../services/httpService";
import { SimpleHBarChart, FilterBar } from "./chartUtils";

const { Option } = Select;

function TicketByAge({ projects }) {
    const navigate = useNavigate();
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const [chartData, setChartData] = useState([]);
    const [chartResults, setChartResults] = useState([]);
    const [assignee, setAssignee] = useState([]);
    const [formData, setFormData] = useState({ staff_id, workauthor_id: "" });

    const {
        status: chartStatus,
        data: chartRes,
        refetch: getChart,
    } = useQuery(
        "ticketByAge",
        async () =>
            await HTTP("/analytics/getJiraTicketsByAgeChart", { ...formData }),
        { enabled: false },
    );

    const {
        status: assigneeStatus,
        data: assigneeRes,
        refetch: fetchWorkLogAuthor,
    } = useQuery(
        "assignee",
        async () => await HTTP("/analytics/getJiraAssignees", { staff_id }),
        { enabled: false },
    );

    useEffect(() => {
        getChart();
        fetchWorkLogAuthor();
    }, []);
    useEffect(() => {
        getChart();
    }, [formData]);

    useEffect(() => {
        if (assigneeStatus === "success") setAssignee(assigneeRes.data);
    }, [assigneeStatus, assigneeRes]);

    useEffect(() => {
        if (chartStatus === "success") {
            const { data } = chartRes;
            setChartResults(data);
            // Build simple [["Range","Tickets"], [label, value], ...] format
            const rows = [
                ["Range", "Tickets"],
                ...data.map((e) => [e.range, e.tickets]),
            ];
            setChartData(rows);
        }
    }, [chartStatus, chartRes]);

    function handleProjectSelectionChange(e) {
        setFormData((prev) => ({
            ...prev,
            project_id: e ? e.split("#")[0] : -1,
        }));
    }

    function handleAssigneeSelectionChange(e) {
        setFormData((prev) => ({
            ...prev,
            workauthor_id: e ? e.split("#")[0] : "",
        }));
    }

    function handleBarClick(entry) {
        // Find matching result by range label and navigate
        const match = chartResults.find((r) => r.range === entry.Range);
        if (match?.id) navigate(`/jira-dashboard/tickets/${match.id}`);
    }

    const isReady = chartStatus !== "loading" && chartStatus !== "idle";

    return (
        <>
            <FilterBar>
                <Select
                    allowClear
                    showSearch
                    placeholder="Project"
                    onChange={handleProjectSelectionChange}
                    style={{ flex: 1, minWidth: 160 }}
                >
                    {projects.map((e) => (
                        <Option key={`${e.project_id}#${e.project_name}`}>
                            {e.project_name}
                        </Option>
                    ))}
                </Select>
                <Select
                    allowClear
                    showSearch
                    placeholder="Work-log Author"
                    onChange={handleAssigneeSelectionChange}
                    style={{ flex: 1, minWidth: 160 }}
                >
                    {assignee.map((e) => (
                        <Option key={`${e.assignee_id}#${e.assignee_name}`}>
                            {e.assignee_name}
                        </Option>
                    ))}
                </Select>
            </FilterBar>
            {isReady && chartData.length > 0 ? (
                <SimpleHBarChart
                    rawData={chartData}
                    height={400}
                    onBarClick={handleBarClick}
                />
            ) : (
                <Skeleton
                    active
                    title={false}
                    paragraph={{ rows: 10, width: "100%" }}
                />
            )}
        </>
    );
}

export default TicketByAge;
